<template>
  <div>
    <van-nav-bar title="特权启动教程">
      <template #right>
        <van-icon name="cross" size="1rem" @click="closePage"/>
      </template>
    </van-nav-bar>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="inner_content" v-html="content"></div>
    </van-pull-refresh>
  </div>
</template>
<script>
import api from "../Api";
export default {
  mixins: [api],
  data() {
    return {
      content: "",
    };
  },
  mounted() {
    this.getTaskCourse();
  },
  methods: {
    getTaskCourse() {
      this.$Ajax("shop/get-task-course").then(rs => {
        if(rs.code == 200) {
          this.content = rs.data.content;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>

</style>
